export const invite = {
    fuwutiaokuan: '《Điều khoản Dịch vụ》',
    yinsizhengce: '《Chính sách Quyền riêng tư》',
    fzcg: 'Sao chép thành công',
    yqhy: "Mời bạn bè",
    fxlj: "Chia sẻ liên kết",
    register_now: 'Đăng ký ngay',
    phone: 'Điện thoại',
    email: 'Email',
    placehold_phone: 'Nhập số điện thoại của bạn',
    placehold_email: 'Nhập địa chỉ email của bạn',
    placehold_code: 'Mã mời',
    argee: 'Tôi đã đọc và đồng ý',
    agreement: '《Thỏa thuận Người dùng BiKing》',
    register: 'Đăng ký',
    phone_code: 'Mã xác nhận qua tin nhắn',
    email_code: 'Mã xác nhận qua email',
    code_to_phone: 'Mã xác nhận đã được gửi dưới dạng tin nhắn đến điện thoại của bạn',
    code_to_email: 'Mã xác nhận đã được gửi dưới dạng email đến địa chỉ email của bạn',
    has_sent: 'Đã gửi mã xác nhận đến:',
    resend: 'Gửi lại',
    send_code: 'Gửi mã xác nhận',
    unable_code: 'Không nhận được mã xác nhận?',
    set_pwd: 'Thiết lập mật khẩu',
    placehold_pwd: 'Nhập mật khẩu của bạn',
    submit: 'Gửi',
    error_phone: 'Vui lòng nhập số điện thoại chính xác',
    error_email: 'Định dạng email không đúng, vui lòng nhập lại',
    error_checked: 'Vui lòng đồng ý với thỏa thuận trước',
    text: 'Định dạng mật khẩu không đúng, mật khẩu phải có từ 8-32 ký tự, bao gồm cả chữ cái viết hoa, chữ cái thường và số.',
    validate: 'Vui lòng hoàn thành quá trình xác nhận',
    register_success: 'Đăng ký thành công!',
    welcome: 'BiKing chào mừng bạn',
    start_trade: 'Nạp tiền và bắt đầu giao dịch tiền điện tử',
    safe: 'Nhiều phương thức nạp tiền, giao dịch tiền điện tử an toàn và thuận tiện',
    pay_type: 'Mua bán tiền điện tử thông qua thẻ ngân hàng hoặc các phương thức thanh toán khác',
    right_now_download: 'Tải về ngay',
    right_download: 'Tải về ngay',
    'Please_enter_correct_phone_number':'Vui lòng nhập số điện thoại chính xác',
    'Referral_code':'Vui lòng nhập mã giới thiệu của bạn',
    'I_have_read_and_agree':'Tôi đã đọc và đồng ý',
    'BiKing_User_Agreement':'《Thỏa thuận Người dùng BiKing》',
    'Please_enter_password':'Vui lòng nhập mật khẩu của bạn',
    'Email_verification_code':'Mã xác nhận qua email',
    'SMS_code':'Mã xác nhận qua tin nhắn',
    'Incorrect_email_format_please_reenter':'Định dạng email không đúng, vui lòng nhập lại',
    'Please_read_and_agree_User_Agreement':'Vui lòng đọc và đồng ý với Thỏa thuận Người dùng',
    'Sent_code_to':'Đã gửi mã xác nhận đến',
    zjff: 'Phát trực tiếp!',
    ycxdz: 'Một lần nhận toàn bộ!',
    bbsy: 'Thu nhập 100 lần với 0 chi phí!',
    sdly: 'Ba lý do chọn BiKing',
    aqfktx: 'Hệ thống an toàn và kiểm soát rủi ro hàng đầu thế giới',
    aqhg: 'An toàn và tuân thủ pháp luật - Mạng lưới giá trị đáng tin cậy - Kiến trúc phân tán chuyên nghiệp và hệ thống chống tấn công DDOS',
    qqbthyytd: 'Đội ngũ quản lý hoạt động cấp quốc gia',
    qqbj: 'Phân bố toàn cầu - Dịch vụ tại nhiều quốc gia - Xây dựng hệ sinh thái blockchain đa dạng về hình thức kinh doanh',
    fwtx: 'Tái tạo hệ thống dịch vụ dựa trên người dùng',
    yhzs: 'Người dùng là trọng tâm - Cơ chế thanh toán tiên tiến độc đáo - Tạo quỹ bảo vệ người dùng',
    jslc: 'Mở khóa quy trình',
    zcwcjkjs: 'Sau khi đăng ký, 1188 USDT sẽ được cấp phát vào tài khoản tiền thưởng và có thể mở khóa bằng cách chuyển vào tài khoản tiền thưởng.',
    czts: 'Ví dụ về thao tác: Sau khi đăng ký thành công, bạn sẽ nhận được 1000 USDT và sử dụng số tiền này để mua hợp đồng đòn bẩy 20 lần với BTC. Khi giá BTC tăng 1%, bạn sẽ có lợi nhuận là 20%, tức là 200 USDT, có thể rút tiền trực tiếp.',
    zhu: 'Chú ý:',
    qzlqyky: '1188 USDT sẽ được cấp phát và nhận trong nhiều đợt, có thể sử dụng cho tất cả các loại hợp đồng',
    gqql: 'Thời hạn sử dụng của 1188 USDT là 1 tháng, hết hạn sẽ bị xóa',
    
  }


// WEBPACK FOOTER //
// ./src/i18n/lang/invite/vi.js